import React from 'react'

const breakpoints = [375, 768, 1128]
const imgSizes = [400, 600, 800]
/**
 * @param {bSizes} [number, number, number, number] - Image sizes under breakpoints [375, 768, 1080, 1200].
 */
const WPCFImage: React.FC<{
  src: string
  width: string
  height: string
  loading?: 'lazy' | 'eager'
  alt?: string
  sizes?: string
  srcset?: string
  quality?: number
  maxViewportWidth?: number
  bSizes?: [number, number, number]
  style?: React.CSSProperties
}> = ({
  src,
  width,
  height,
  loading = 'lazy',
  alt = 'image',
  sizes,
  srcset,
  quality = 75,
  maxViewportWidth = 70,
  bSizes = breakpoints,
  style,
}) => {
  let publicSrc = src
  let publicSrcset = srcset
  let publicSizes = sizes

  if (publicSrc.startsWith(process.env.CONTENT_HUB_ENDPOINT)) {
    publicSrc = src.replace(
      `${process.env.CONTENT_HUB_ENDPOINT}/wp-content/uploads/`,
      ``
    )
    const bPoints = breakpoints // Define the different sizes you want to support
    const imageSrcSet = imgSizes.map(
      (size) =>
        `${process.env.GATSBY_WORDPRESS_CACHE_BASE}/cdn-cgi/image/width=${size},quality=${quality}/wp_media/${publicSrc} ${size}w `
    )
    const imageSizes = bPoints.map(
      (size, index) => `(max-width: ${size}px) ${bSizes[index]}px`
    )
    if (!publicSizes) {
      publicSizes = imageSizes.join(', ') + `, ${maxViewportWidth}vw`
    }
    if (!publicSrcset) {
      publicSrcset = imageSrcSet.join(', ')
    }

    publicSrc = `${process.env.GATSBY_WORDPRESS_CACHE_BASE}/wp_media/${publicSrc}`
  }
  return (
    <img
      src={publicSrc}
      width={width}
      height={height}
      alt={alt}
      srcSet={publicSrcset}
      sizes={publicSizes}
      loading={loading}
      referrerPolicy="no-referrer"
      style={{ width: '100%', objectFit: 'cover', height: 'auto', ...style }}
    />
  )
}

export default WPCFImage
